module.exports = __webpack_public_path__ + "img/clear.abfbf956.svg";